import { z } from 'zod';

export const SPARK_MAX = 140;

export const REACTIONS = ['🔥', '😅', '👀', '🫡', '💯'] as const;
export const ReactionSchema = z.enum(REACTIONS);
export type Reaction = z.infer<typeof ReactionSchema>;

/** Ready-made openers shown in the compose sheet. */
export const SPARK_OPENERS = [
  'your fit is unreal 🔥',
  'great taste in music 🎧 what are you listening to?',
  'front-row energy 💥',
  'come say hi in the Circle 👋',
  'that smile though 😅',
  'vibe check: passed 🫡',
] as const;

/**
 * Where the sender is standing, from the RECEIVER's point of view (receiver
 * facing "front"). The sender can see the receiver, so they pick this; the
 * receiver then knows which way to look.
 */
export const SPARK_DIRECTIONS = [
  'front',
  'front_left',
  'left',
  'back_left',
  'back',
  'back_right',
  'right',
  'front_right',
] as const;
export const SparkDirectionSchema = z.enum(SPARK_DIRECTIONS);
export type SparkDirection = z.infer<typeof SparkDirectionSchema>;

/** Compass angle in degrees for a direction (0 = receiver's front, clockwise). */
export const DIRECTION_DEG: Record<SparkDirection, number> = {
  front: 0,
  front_right: 45,
  right: 90,
  back_right: 135,
  back: 180,
  back_left: 225,
  left: 270,
  front_left: 315,
};

/** Receiver-facing copy, kept playful. */
export const DIRECTION_COPY: Record<SparkDirection, string> = {
  front: 'right in front of you 👀',
  front_left: 'front-left, just off your shoulder ↖️',
  left: 'on your left 👈',
  back_left: 'behind you, to the left 🫣',
  back: 'directly behind you 🫣',
  back_right: 'behind you, to the right 🫣',
  right: 'on your right 👉',
  front_right: 'front-right, dead ahead-ish ↗️',
};

/* POST /api/spark — send a Spark request (anonymous). Text is held until the
   receiver accepts. */
export const SendSparkSchema = z.object({
  spotId: z.string(),
  toPseudoId: z.string(),
  text: z.string().trim().min(1).max(SPARK_MAX),
  /** Where the sender is, from the receiver's POV. */
  direction: SparkDirectionSchema,
});
export type SendSpark = z.infer<typeof SendSparkSchema>;

export const SendSparkResponseSchema = z.object({
  threadId: z.string(),
  status: z.enum(['pending', 'accepted']),
  /** Seconds until another spark may be sent (rate limit). */
  cooldown: z.number().int().nonnegative(),
});
export type SendSparkResponse = z.infer<typeof SendSparkResponseSchema>;
